// Module
var code = "Vous participez désormais<br> au tirage au sort final";
// Exports
module.exports = code;